/**
 * Cyber Advice — API Service
 * Backend bilan barcha muloqot shu fayl orqali
 */

const host = window.location.hostname;
const protocol = window.location.protocol;
let backendBase;

if (host.includes('botoperator.unistart-hub.uz')) {
  backendBase = 'https://botoperatorapi.unistart-hub.uz/api/v1';
} else if (host.includes('bestcenter.uz')) {
  backendBase = 'https://api.bestcenter.uz/api/v1';
} else if (protocol === 'https:') {
  backendBase = `https://${host}/api/v1`;
} else {
  backendBase = `http://${host}:7703/api/v1`;
}

export const BASE = import.meta.env.VITE_API_URL || backendBase;
let activeBase = BASE;

// Export WebSocket URL builder
export function getWsUrl(path) {
  const wsBase = activeBase.replace('http://', 'ws://').replace('https://', 'wss://');
  return `${wsBase}${path}`;
}

// avatar_url ('/api/v1/avatars/..') ni to'liq URL ga aylantirish (barcha sahifalar uchun)
const API_ORIGIN = BASE.replace(/\/api\/v1\/?$/, '')
export function resolveAvatarUrl(url) {
  if (!url) return null
  if (/^https?:\/\//.test(url)) return url
  return activeBase.replace(/\/api\/v1\/?$/, '') + url
}

const getToken  = () => localStorage.getItem('access_token')
const getRefresh = () => localStorage.getItem('refresh_token')
const setTokens = (access, refresh) => {
  localStorage.setItem('access_token', access)
  if (refresh) localStorage.setItem('refresh_token', refresh)
}
const clearTokens = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('crt_user')
}

async function apiFetch(path, options = {}, isRetry = false) {
  const token = getToken()
  const headers = { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers }
  
  let res;
  try {
    res = await fetch(`${activeBase}${path}`, { ...options, headers })
  } catch (err) {
    if (err?.name === 'AbortError') throw err // bekor qilingan so'rov — fallback shart emas
    if (!isRetry && (host === 'localhost' || host === '127.0.0.1')) {
      console.warn(`[API] Asosiy serverga ulanib bo'lmadi (${activeBase}). Lokal backendga o'tilmoqda...`);
      activeBase = 'http://localhost:7703/api/v1';
      return apiFetch(path, options, true);
    }
    throw new Error("Server bilan aloqa yo'q (Internet yoki CORS xatosi)");
  }

  if (res.status === 401 && getRefresh()) {
    const ok = await refreshAccessToken()
    if (ok) { headers.Authorization = `Bearer ${getToken()}`; res = await fetch(`${activeBase}${path}`, { ...options, headers }) }
    else {
      clearTokens(); window.location.href = '/login'
      // Redirect ketmoqda — chaqiruvchiga undefined qaytarmaslik uchun hech qachon resolve bo'lmaydigan promise
      return new Promise(() => {})
    }
  } else if (res.status === 401) {
    // Refresh token yo'q — sessiya tugagan, tokenlarni tozalab login sahifasiga yo'naltiramiz
    clearTokens(); window.location.href = '/login'
    return new Promise(() => {})
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }))
    throw new Error(err.detail || 'API xatosi')
  }
  if (res.status === 204) return null
  return res.json()
}

// Parallel 401 lar bitta /auth/refresh so'roviga birlashadi (de-dup)
let refreshInFlight = null
function refreshAccessToken() {
  if (refreshInFlight) return refreshInFlight
  refreshInFlight = (async () => {
    const refresh = getRefresh()
    if (!refresh) return false
    try {
      const res = await fetch(`${activeBase}/auth/refresh`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ refresh_token: refresh }) })
      if (res.ok) {
        const data = await res.json()
        // Server refresh tokenni aylantirgan (rotate qilgan) bo'lsa — yangisini saqlaymiz
        setTokens(data.access_token, data.refresh_token || null)
        return true
      }
    } catch {}
    return false
  })().finally(() => { refreshInFlight = null })
  return refreshInFlight
}

const get  = (path, opts) => apiFetch(path, opts) // opts: masalan { signal } (AbortController)
const post = (path, body) => apiFetch(path, { method: 'POST', body: JSON.stringify(body) })
const put  = (path, body) => apiFetch(path, { method: 'PUT', body: JSON.stringify(body) })
const del  = (path) => apiFetch(path, { method: 'DELETE' })

export const api = { get, post, put, delete: del }
export default api

// AUTH
export const authApi = {
  login: async (username, password, totp_code = null) => {
    const res = await fetch(`${BASE}/auth/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password, totp_code }) })
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.detail || 'Login xatosi') }
    const data = await res.json()
    setTokens(data.access_token, data.refresh_token)
    localStorage.setItem('crt_user', JSON.stringify(data.user))
    return data
  },
  logout: async () => { try { await post('/auth/logout') } catch {} clearTokens(); window.location.href = '/login' },
  getMe: () => get('/me'),
  myStats: () => get('/me/stats'),
  updateMe: (body) => put('/me', body),
  changePassword: (body) => put('/me/password', body),
  enable2FA: () => post('/me/2fa/enable', {}),
  verify2FA: (code) => post('/me/2fa/verify', { code }),
  disable2FA: (code) => post('/me/2fa/disable', { code }),
  heartbeat: () => post('/me/heartbeat', {}).catch(() => {}),
  uploadAvatar: async (file) => {
    const token = getToken()
    const form = new FormData()
    form.append('file', file, file.name || 'avatar.jpg')
    const res = await fetch(`${BASE}/me/avatar`, { method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form })
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Avatar yuklashda xato') }
    return res.json()
  },
  deleteAvatar: () => del('/me/avatar'),
  getCachedUser: () => { try { return JSON.parse(localStorage.getItem('crt_user')) } catch { return null } },
  isAuthenticated: () => !!getToken(),
}

export const feedbackApi = {
  list: (params = {}) => { const q = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v != null && v !== '' && v !== false))).toString(); return get(`/feedback${q ? '?' + q : ''}`) },
}

export const dashboardApi = {
  stats: (opts) => get('/dashboard/stats', opts),
  trend: (days = 30, opts) => get(`/dashboard/trend?days=${days}`, opts),
  sparklines: (days = 12, opts) => get(`/dashboard/sparklines?days=${days}`, opts),
  byCategory: (opts) => get('/dashboard/by_category', opts),
  operatorsStats: (opts) => get('/dashboard/operators_stats', opts),
}

export const ticketsApi = {
  list: (params = {}, opts) => {
    const q = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v != null && v !== ''))).toString()
    return get(`/tickets${q ? '?' + q : ''}`, opts)
  },
  get: (id) => get(`/tickets/${id}`),
  getFull: (id) => get(`/tickets/${id}/full`),
  update: (id, body) => put(`/tickets/${id}`, body),
  accept: (id) => post(`/tickets/${id}/accept`, {}),
  getMessages: (id, opts) => get(`/tickets/${id}/messages`, opts),
  sendMessage: (id, body) => post(`/tickets/${id}/messages`, body),
  getHistory: (id) => get(`/tickets/${id}/history`),
}

export const operatorsApi = {
  list: (params = {}) => { const q = new URLSearchParams(params).toString(); return get(`/operators${q ? '?' + q : ''}`) },
  get: (id) => get(`/operators/${id}`),
  create: (body) => post('/operators', body),
  update: (id, body) => put(`/operators/${id}`, body),
  resetPassword: (id, newPassword) => put(`/operators/${id}/password`, { new_password: newPassword }),
  updatePermissions: (id, permissions) => put(`/operators/${id}/permissions`, { permissions }),
  availablePermissions: () => get('/permissions/available'),
  delete: (id) => del(`/operators/${id}`),
  // AI operator profillari
  createAi: (full_name) => post('/operators/ai', { full_name }),
  uploadAvatar: (id, file) => {
    const form = new FormData(); form.append('file', file)
    const token = localStorage.getItem('access_token')
    return fetch(`${import.meta.env.VITE_API_URL || '/api/v1'}/operators/${id}/avatar`, {
      method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form,
    }).then(async r => { if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || 'Avatar xatosi'); return r.json() })
  },
}

// Foydalanuvchilar sahifasi: bo'sh filtr so'rovga qo'shilmaydi
// (URLSearchParams undefined ni "undefined" satriga aylantirib yuborardi)
const qs = (params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== '' && v != null)
  ).toString()
  return q ? `?${q}` : ''
}

export const usersApi = {
  summary: () => get('/users/summary'),
  list: (params) => get(`/users${qs(params)}`),
  create: (body) => post('/users', body),
  update: (id, body) => put(`/users/${id}`, body),
  delete: (id) => del(`/users/${id}`),          // → { mode: 'deleted' | 'deactivated' }
  resetPassword: (id, newPassword) => put(`/operators/${id}/password`, { new_password: newPassword }),
}

export const citizensApi = {
  list: (params) => get(`/citizens${qs(params)}`),
  get: (id) => get(`/citizens/${id}`),
  create: (body) => post('/citizens', body),
  update: (id, body) => put(`/citizens/${id}`, body),
  delete: (id) => del(`/citizens/${id}`),       // murojaatlari bilan birga
}

export const botsApi = {
  list: () => get('/bots'),
  add: (body) => post('/bots', body),
  update: (id, body) => put(`/bots/${id}`, body),
  delete: (id) => del(`/bots/${id}`),
  status: () => get('/bots/status'),
}

export const categoriesApi = {
  // all=true — o'chirilganlari ham (boshqaruv sahifasi uchun): turkumni
  // o'chirish SOFT va kaskadsiz, ichida ticket/shablon/resurs qolib ketadi,
  // shuning uchun uni ko'rish va qaytarish imkoni bo'lishi kerak.
  list: (all = false) => get(all ? '/categories?all=true' : '/categories'),
  create: (body) => post('/categories', body),
  update: (id, body) => put(`/categories/${id}`, body),
  delete: (id) => del(`/categories/${id}`),
}

export const faqApi = {
  list: () => get('/faq'),
  create: (body) => post('/faq', body),
  update: (id, body) => put(`/faq/${id}`, body),
  delete: (id) => del(`/faq/${id}`),
  use: (id) => post(`/faq/${id}/use`, {}),
}

export const templatesApi = {
  // all=true — nofaol (qoralama) shablonlar ham keladi; faqat boshqaruv huquqi borlar uchun
  list: (all = false) => get('/templates' + (all ? '?all=true' : '')),
  create: (body) => post('/templates', body),
  update: (id, body) => put(`/templates/${id}`, body),
  delete: (id) => del(`/templates/${id}`),
  use: (id) => post(`/templates/${id}/use`, {}),
  // AI tarjima: { text, target: 'uz_cy' | 'ru' } -> { text }
  translate: (body) => post('/templates/translate', body),
}

// Premium emoji kutubxonasi — botga yuborilgan animatsion emojilar.
// file_url backenddan nisbiy keladi ('/api/v1/emojis/<id>/file'), uni
// avatarlar kabi to'liq manzilga aylantiramiz: <img>/<video> token yubormaydi.
export const emojisApi = {
  list: async () => {
    const rows = await get('/emojis')
    return (rows || []).map(e => ({ ...e, file_url: resolveAvatarUrl(e.file_url) }))
  },
  delete: (ceid) => del(`/emojis/${ceid}`),
}

export const settingsApi = {
  get: () => get('/settings'),
  update: (body) => put('/settings', body),
}

// Avto AI operator (Claude)
export const aiApi = {
  getConfig: () => get('/ai/config'),
  updateConfig: (body) => put('/ai/config', body),
  test: (body = {}) => post('/ai/test', body),
  usage: () => get('/ai/usage'),
  suggestReply: (ticketId) => post('/ai/suggest-reply', { ticket_id: ticketId }),
  // Jurnal. Bo'sh/false qiymatlar so'rovga tushmaydi — backend ularni
  // "filtr berilgan" deb qabul qilib qo'ymasligi uchun.
  // DIQQAT: `include_prompt` ni polling'da BERMANG — 30 000 belgilik system
  // prompt har qator bilan birga keladi. To'liq prompt uchun `logDetail()`.
  logs: (params = {}) => {
    const q = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== '' && v !== false))
    ).toString()
    return get(`/ai/logs${q ? '?' + q : ''}`)
  },
  flagLog: (id, flagged, note) => post(`/ai/logs/${id}/flag`, { flagged, note }),
  // Bitta chaqiruvning TO'LIQ tafsiloti: system prompt, suhbat, javob,
  // raw_request (provayder shaklida, backendda qurilgan), FAQ lar, sarf.
  logDetail: (id) => get(`/ai/logs/${id}`),
  // kinds: 'reply' (standart, eski xulq) | 'all' | 'reply,tmpl_pick'
  stats: (days = 14, kinds = null) => get(`/ai/stats?days=${days}${kinds ? `&kinds=${encodeURIComponent(kinds)}` : ''}`),
  // Sahifaning butun analitikasi bitta so'rovda (voronka, turkum, til, kesh, …)
  analytics: (days = 30) => get(`/ai/analytics?days=${days}`),
  // Video/havola bo'shliqlari (bot bermoqchi bo'lgani-yu bazada yo'q)
  resourceGaps: (params = {}) => { const q = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v != null && v !== ''))).toString(); return get(`/ai/resource-gaps${q ? '?' + q : ''}`) },
  updateGap: (id, body) => put(`/ai/resource-gaps/${id}`, body),
  deleteGap: (id) => del(`/ai/resource-gaps/${id}`),
}

export const vtApi = {
  getConfig: () => get('/vt/config'),
  updateConfig: (body) => put('/vt/config', body),
  testKey: (api_key) => post('/vt/test', { api_key }),
}

// Kanal bazasi (t.me kanal tarixi)
export const channelApi = {
  startSync: (channel, mode = 'new') => post('/channel/sync', { channel, mode }),
  syncStatus: () => get('/channel/sync/status'),
  stats: () => get('/channel/stats'),
  posts: (params = {}) => { const q = new URLSearchParams(params).toString(); return get(`/channel/posts${q ? '?' + q : ''}`) },
  toFaq: (id, body) => post(`/channel/posts/${id}/to-faq`, body),
  suggestQuestion: (id) => post(`/channel/posts/${id}/suggest-question`, {}),
  // AI ommaviy saralash
  classifyStart: (onlyNew = true) => post('/channel/classify', { only_unprocessed: onlyNew }),
  classifyStatus: () => get('/channel/classify/status'),
  classifyCancel: () => post('/channel/classify/cancel', {}),
  // AVTO rejim + eksport
  getAuto: () => get('/channel/auto'),
  setAuto: (enabled) => post('/channel/auto', { enabled }),
  exportUrl: () => `${import.meta.env.VITE_API_URL || '/api/v1'}/channel/export`,
}

export const auditApi = {
  list: (params = {}) => { const q = new URLSearchParams(params).toString(); return get(`/audit${q ? '?' + q : ''}`) },
}

// Server paneli: alohida qisqa muddatli sessiya tokeni (2FA step-up).
// Oddiy access token /server/* uchun YARAMAYDI.
const SRV_KEY = 'server_token'
export const getServerToken = () => sessionStorage.getItem(SRV_KEY) || ''
export const setServerToken = (t) => t ? sessionStorage.setItem(SRV_KEY, t) : sessionStorage.removeItem(SRV_KEY)
export const clearServerToken = () => sessionStorage.removeItem(SRV_KEY)

async function srv(path, options = {}) {
  const t = getServerToken()
  const headers = {
    'Content-Type': 'application/json',
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
    ...options.headers,
  }
  const res = await fetch(`${activeBase}${path}`, { ...options, headers })
  if (res.status === 401) { clearServerToken(); throw new Error('SERVER_SESSION_REQUIRED') }
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.detail || `HTTP ${res.status}`)
  return data
}

export const serverApi = {
  // 2FA kodi bilan sessiya ochish
  openSession: async (totp_code) => {
    const data = await post('/server/session', { totp_code })
    if (data?.server_token) setServerToken(data.server_token)
    return data
  },
  hasSession: () => !!getServerToken(),
  closeSession: () => clearServerToken(),

  getDomains: () => srv('/server/domains'),
  addDomain: (domain, target_port) => srv(`/server/domains?domain=${encodeURIComponent(domain)}&target_port=${target_port}`, { method: 'POST', body: '{}' }),
  issueSsl: (domain) => srv(`/server/ssl?domain=${encodeURIComponent(domain)}`, { method: 'POST', body: '{}' }),
  getCommits: (limit = 10) => srv(`/server/commits?limit=${limit}`),
  getLogs: (container = 'crt-backend') => srv(`/server/logs?container=${container}`),
  getMetrics: () => srv('/server/metrics'),

  // CI/CD tarixi
  listDeployments: (limit = 30) => srv(`/server/deployments?limit=${limit}`),
  getDeployment: (id) => srv(`/server/deployments/${id}`),
  analyzeDeployment: (id) => srv(`/server/deployments/${id}/analyze`, { method: 'POST', body: '{}' }),
  analyzeLogs: (container, logs) => srv('/server/logs/analyze', {
    method: 'POST', body: JSON.stringify({ container, logs }),
  }),
}

export function createWebSocket(userId, onMessage) {
  // MUHIM: WebSocket backend (`/ws`) API host'да joylashgan (masalan
  // botoperatorapi.unistart-hub.uz / api.bestcenter.uz), frontend host'да EMAS.
  // Ilgari WS `window.location.host` (frontend, 7704) ga ulanardi — u yerda
  // nginx `/ws` ni proksi qilmaydi va Upgrade header yo'q, shu sabab ulanish
  // jimgina uzilib, HECH QANDAY bildirishnoma kelmasdi. Endi WS'ni API
  // origin'дан quramiz — u yerda `/ws` proksi va WebSocket Upgrade sozlangan.
  const apiOrigin = activeBase.replace(/\/api\/v1\/?$/, '')       // https://<api-host>
  const wsBase = import.meta.env.VITE_WS_URL ||
    apiOrigin.replace(/^http/, 'ws')                               // wss://<api-host>
  const base = wsBase
  let ws = null
  let pingInterval = null
  let reconnectTimeout = null
  let retries = 0
  let destroyed = false

  const connect = () => {
    if (destroyed) return
    // Oldingi WS ni yopish
    if (ws && ws.readyState !== WebSocket.CLOSED) {
      ws.onclose = null // loop oldini olish
      ws.close()
    }

    const token = localStorage.getItem('access_token') || ''
    const url = `${base}/ws/${userId}${token ? '?token=' + encodeURIComponent(token) : ''}`

    try { ws = new WebSocket(url) } catch { return }

    ws.onopen = () => {
      retries = 0
      clearInterval(pingInterval)
      pingInterval = setInterval(() => {
        if (ws?.readyState === WebSocket.OPEN) ws.send('ping')
      }, 25000)
    }

    ws.onmessage = (e) => {
      if (e.data === 'pong') return
      try { onMessage(JSON.parse(e.data)) } catch {}
    }

    ws.onclose = () => {
      clearInterval(pingInterval)
      clearTimeout(reconnectTimeout)
      if (!destroyed && retries < 8) {
        const delay = Math.min(2000 * Math.pow(1.5, retries), 30000)
        retries++
        reconnectTimeout = setTimeout(connect, delay)
      }
    }

    ws.onerror = () => {} // onclose ni trigger qiladi
  }

  connect()

  return {
    close: () => {
      destroyed = true
      clearInterval(pingInterval)
      clearTimeout(reconnectTimeout)
      if (ws) { ws.onclose = null; ws.close() }
    }
  }
}

export function getApiBase() {
  return activeBase;
}

export async function sendFileToTicket(ticketId, blob, fileType, caption = '', filename = '') {
  const token = localStorage.getItem('access_token') || ''
  const BASE  = activeBase
  const form  = new FormData()
  form.append('file', blob, filename || `${fileType}.${blob.type.split('/')[1] || 'bin'}`)
  form.append('file_type', fileType)
  form.append('caption', caption)
  const res = await fetch(`${BASE}/tickets/${ticketId}/send-file`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.detail || 'Fayl yuborishda xato')
  }
  return res.json()
}

export async function blockCitizen(citizenId, reason = '') {
  const token = localStorage.getItem('access_token') || ''
  const BASE  = activeBase
  const res   = await fetch(`${BASE}/citizens/${citizenId}/block`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  })
  if (!res.ok) throw new Error('Bloklashda xato')
  return res.json()
}

export async function unblockCitizen(citizenId) {
  const token = localStorage.getItem('access_token') || ''
  const BASE  = activeBase
  const res   = await fetch(`${BASE}/citizens/${citizenId}/unblock`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Blokdan chiqarishda xato')
  return res.json()
}

export const backupsApi = {
  list: () => get('/backups'),
  create: () => post('/backups/create', {}),
  restore: (filename) => post(`/backups/restore/${filename}`, {}),
  remove: (filename) => del(`/backups/${filename}`),
  downloadUrl: (filename) => `${activeBase}/backups/download/${filename}`,
}

// Offsite zahira — Cloudflare R2
export const r2Api = {
  getConfig:    () => get('/backups/r2/config'),
  updateConfig: (body) => put('/backups/r2/config', body),
  test:         () => post('/backups/r2/test', {}),
  list:         () => get('/backups/r2/list'),
  upload:       (filename) => post(`/backups/r2/upload/${filename}`, {}),
  pull:         (key) => post('/backups/r2/pull', { key }),
  remove:       (key) => post('/backups/r2/delete', { key }),
}

